import {HashRouter,Routes,Route} from 'react-router-dom'
import { Helmet } from 'react-helmet';

import HomePage from './Home/HomePage';
import Contact from './Contact/Contact';
import OurStudio from './Our Studio/OurStuido';
import OurStudioClassDetails from './OurClass/ClassComponents/OurClassDetails';


export function App() {
    return (
      <>
       <Helmet>
        <title>Abcd Studio Salem</title>
        <meta name="description" content="Welcome to our studio! Explore our latest events, backstage content, and more." />
        <meta name="keywords" content="Salem Studio, Salem Events, Salem Dance, Salem Art, Salem Performance, Dance Studio, Art Gallery, Live Events, 
        Event Space, Dance Classes, Art Workshops, Stage Performance, Local Artists, Venue Hire, Backstage Access, Salem Dance Studio, Salem Art Gallery, 
        Salem Event Venue, Salem Performance Space, Best Dance Classes, Top Art Workshops, Live Music Salem, Creative Studio Salem, Professional Dance Studio, 
        Art Exhibition Salem, Performance Arts Salem, Backstage Support Salem, Event Management Salem, Dance Performance Salem, Art Studio Salem, Best Dance Studio Salem, 
        Top Art Gallery Salem, Premier Event Venue Salem, Professional Dance Classes Salem, Live Performance Venue Salem, Salem Performing Arts Center, Creative Art Studio Salem, 
        Salem Backstage Facilities, Local Artists Salem Exhibitions, Dance Performance Events Salem, Art Workshop Classes Salem, Salem Event Management Services, 
        Modern Dance Studio Salem, Traditional Art Gallery Salem, Community Performance Space Salem, Best Multi-purpose Studio for Events in Salem, Top Rated Dance and Art Performance Venue Salem, 
        Professional Backstage Facilities for Events in Salem, Comprehensive Dance and Art Education Programs Salem, Premier Destination for Live Performances and Events Salem, 
        Salem's Leading Studio for Creative Arts and Dance, Exclusive Event Space with Backstage Access in Salem, High-Quality Dance Training and Performance Opportunities Salem, 
        Showcasing Local Art and Talent in Salem Events, State-of-the-Art Performance Venue for Artists in Salem" />
      </Helmet>
      <div className="App">
        {/* <NavBar/> */}
        <HashRouter>
            <Routes>
                <Route path="/" element={<HomePage />}/>
                <Route path="contact" element={<Contact />}/>
                <Route path="our-studio" element={<OurStudio />}/>
                <Route path="class-details" element={<OurStudioClassDetails />}/>
            </Routes>
        </HashRouter>
      </div>
      </>
    );
}